import React from 'react';
import Image1 from '../../asset/Image1.jpeg';
import Image2 from '../../asset/Image2.jpeg';
import Image3 from '../../asset/Image3.jpeg';
import Image4 from '../../asset/Image4.jpeg';
import Image5 from '../../asset/Image5.jpeg';
import Image6 from '../../asset/Image6.jpeg';
import Image7 from '../../asset/Image7.jpeg';
import Image8 from '../../asset/Image8.jpeg';
import Image9 from '../../asset/Image9.jpeg';

const Gallery = () => {
  const images = [Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8, Image9];

  return (
    <div className="gallery-container">
      <h2 className="gallery-title heading">Gallery</h2>
      <div className="gallery-grid">
        {images.map((img, idx) => (
          <div className="gallery-item" key={idx}>
            <img src={img} alt={`Gallery ${idx + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
